
import { Grid } from '@mui/material';
import { useCallback, useState, useMemo } from 'react';
import { useLanguageContext } from '../../../../contexts/LanguageContext';
import Drawer, { IDefaultDrawerProps } from '../../../../components/Drawer';
import { ActionButton } from '../../../../components/Button';
import TextField from '../../../../components/TextField';
import SelectField from '../../../../components/SelectField';
import FormHelper from '../../../../helpers/FormHelper';
import { RegistrationStatusData, RegistrationStatusEnum } from '../../../../data/Enums';
import DateField from '../../../../components/DateField';
import Operators from '../../../../data/Operators';


interface IEnterpriseFilterProps extends IDefaultDrawerProps {
    handleApplyFilters: (formData: FormData) => void;
}


const Filters: React.FC<IEnterpriseFilterProps> = ({
    open,
    handleClose,
    handleApplyFilters
}) => {
    const { translate } = useLanguageContext();

    const [name, setName] = useState<string>('');
    const [expirationOperator, setExpirationOperator] = useState<string>(Operators[0]);
    const [expiration, setExpiration] = useState<Date | undefined>(undefined);
    const [registrationStatus, setRegistrationStatus] = useState<number[]>([RegistrationStatusEnum.Actived, RegistrationStatusEnum.Inactived]);


    const handleSubmit = useCallback((event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const formData = FormHelper.Create(event);
        handleApplyFilters(formData);
        handleClose();
        // eslint-disable-next-line
    }, []);


    const footer = useMemo(() => {
        return <ActionButton
            action='apply'
            fullWidth={true}
            className='text-alwaysshow'
            type='submit'
        />;
        // eslint-disable-next-line
    }, [translate]);
    

    return (
        <Drawer
            anchor='right'
            open={open}
            handleClose={handleClose}
            title={translate('filter')}
            footer={footer}
            onSubmit={handleSubmit}
        >
            <Grid container>
                <Grid item xs={12}>
                    <TextField 
                        label={translate('name')} 
                        name='name' 
                        value={name} 
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
                        required={false}
                    />
                </Grid>

                <Grid item xs={4}>
                    <SelectField
                        label={translate('operator')}
                        name='expirationOperator'
                        value={expirationOperator}
                        required={true}
                        onChange={e => setExpirationOperator(e.target.value)}
                        data={Operators}
                    />
                </Grid>

                <Grid item xs={8}>
                    <DateField
                        label={translate('expiration')}
                        format='DD/MM/YYYY'
                        name='expiration'
                        value={expiration}
                        onChange={value => setExpiration(value)}
                        required={false}
                    />
                </Grid>
                
                <Grid item xs={12}>
                    <SelectField
                        label={translate('situation')}
                        name='registrationStatus'
                        value={registrationStatus}
                        multiple={true}
                        required={true}
                        onChange={e => setRegistrationStatus(e.target.value)}
                        data={Object.values(RegistrationStatusData).filter(s => s.visible).map(s => {
                            return {
                                value: s.id,
                                text: translate(s.name)
                            };
                        })}
                    />
                </Grid>
            </Grid>
        </Drawer>
    );
}

export default Filters;